var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBlock)?_c('div',{staticClass:"word-count"},[_c('p',[_vm._v(_vm._s(_vm.wordCount))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }